<template>
  <div class="donut">
    <canvas ref="canvasRef"></canvas>
  </div>
</template>

<script setup>
import { nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import Chart from 'chart.js/auto';

const props = defineProps({
  segments: {
    type: Array,
    default: () => []
  }
});

const canvasRef = ref(null);
let chart = null;

function destroyChart() {
  if (chart) {
    chart.destroy();
    chart = null;
  }
}

async function renderChart() {
  await nextTick();
  if (!canvasRef.value) return;

  destroyChart();

  const data = (props.segments || []).map((item) => Number(item?.value || 0));
  const backgroundColor = (props.segments || []).map((item) => item?.color || '#cccccc');

  chart = new Chart(canvasRef.value.getContext('2d'), {
    type: 'doughnut',
    data: {
      datasets: [
        {
          data,
          backgroundColor,
          borderWidth: 0
        }
      ]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      cutout: '75%',
      plugins: {
        tooltip: { enabled: false },
        legend: { display: false }
      }
    }
  });
}

watch(
  () => props.segments,
  () => {
    renderChart();
  },
  { deep: true }
);

onMounted(() => {
  renderChart();
});

onBeforeUnmount(() => {
  destroyChart();
});
</script>

<style scoped>
.donut {
  width: 280px;
  height: 280px;
}

.donut canvas {
  width: 280px;
  height: 280px;
}

@media screen and (max-width: 768px) {
  .donut {
    width: 220px;
    height: 220px;
  }

  .donut canvas {
    width: 220px;
    height: 220px;
  }
}
</style>
